import { List } from '@components/List/List';
import { ListSectionProps } from '@components/List/list.types';
import { ScreenHeader } from '@components/ScreenHeader';
import { TabScreenContainer } from '@components/TabScreenContainer';
import { Ionicons } from '@expo/vector-icons';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { Linking } from 'react-native';
import { ScrollView, YStack } from 'tamagui';
import { ABOUT_URL, FAQ_URL, SUPPORT_EMAIL } from './resourcesScreen.constants';
import { useIsWeb } from '@hooks/useIsWeb';
import { useAssetsGetAsset } from '@api/WhisApi/generated';

export default function ResourcesScreen(): React.ReactNode {
  const { t, language } = useAppTranslation();
  const device = useIsWeb() ? 'web' : 'mobile';
  const trainingMaterialName = `trainingMaterial-WildEpi-${device}-${language}.mp4`;
  const { data: trainingMaterial, isPending: trainingMaterialIsPending } =
    useAssetsGetAsset(trainingMaterialName);

  const sections: ListSectionProps[] = [
    {
      id: 'learning-material',
      title: t('resources.learningMaterial'),
      items: [
        {
          id: 'training-videos',
          title: t('resources.trainingVideos'),
          iconAfter: <Ionicons name="open-outline" />,
          onPress: (): void => {
            if (!trainingMaterialIsPending && trainingMaterial) {
              void Linking.openURL(trainingMaterial.url);
            }
          },
        },
        {
          id: 'about',
          title: t('resources.about'),
          iconAfter: <Ionicons name="open-outline" />,
          onPress: (): void => {
            void Linking.openURL(ABOUT_URL);
          },
        },
      ],
    },
    {
      id: 'help-support',
      title: t('resources.helpAndSupport'),
      items: [
        {
          id: 'faqs',
          title: t('resources.faqs'),
          iconAfter: <Ionicons name="open-outline" />,
          onPress: (): void => {
            void Linking.openURL(FAQ_URL);
          },
        },
        {
          id: 'report-bug',
          title: t('resources.reportBug'),
          iconAfter: <Ionicons name="open-outline" />,
          onPress: (): void => {
            void Linking.openURL(`mailto:${SUPPORT_EMAIL}`);
          },
        },
      ],
    },
  ];

  return (
    <TabScreenContainer>
      <ScreenHeader title={t('navigation.resources')} />

      <ScrollView>
        <YStack alignItems="center">
          <YStack gap="$true" maxWidth="$compactPageWidth" width="100%">
            <List sections={sections} />
          </YStack>
        </YStack>
      </ScrollView>
    </TabScreenContainer>
  );
}
